// https://tobiasahlin.com/spinkit/

import '../css/ShuffleSpinner.css';

function ShuffleSpinner() {
	return (
		<div className="spinner">
			<div className="cube1"></div>
			<div className="cube2"></div>
		</div>
	);
}

export default ShuffleSpinner;
